// extracted by mini-css-extract-plugin
export default {"wrapper":"Header_wrapper__r1+ms","navItem":"Header_navItem__ehw-3","labelText":"Header_labelText__DxZGq","active":"Header_active__rHuVo"};